module.exports = __webpack_public_path__ + "img/plus-circle-fill.3a65fb7c.svg";